export default "__VITE_ASSET__tg4jqsA9__"